import store from "@/store";

export const userMenu = [
    {
        label: "Выход",
        icon: "pi pi-sign-out",
        command: () => {
            store.dispatch("user/LOGOUT");
        },
        to: "/login",
    },
];
